import { Link } from "react-router-dom";
import styled from "styled-components";

export const CreatorCardWrapper = styled(Link)`
  width: 299px;
  display: flex;
  align-items: center;
  margin: 20px auto;
  padding: 10px;
`;

export const CreatorNumber = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 126.2%;
  color: ${(props) => props.theme.textColor};
  margin-right: 15px;
  width: 20px;
`;

export const CreatorAvatar = styled.div`
  width: 75px;
  height: 75px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 15px;
`;

export const CreatorInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 55px;
  & h5 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  & span {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 126.2%;
    color: ${(props) => props.theme.subtitleColor};
    display: flex;
    align-items: center;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    & img {
      width: 24px;
      margin-right: 5px;
    }
  }
`;
